<template>
  <div>

    <div class="sayfahead">
      <h1>{{ SayfaAdi }}</h1>
    </div>
    <div class="icerik">
      <Yukleniyor :data="lo"></Yukleniyor>
      <div class="raporbloksabitle">
        <el-row :gutter="24">
          <el-form
            :model="Form"
            :rules="FormHata"
            @submit.prevent.native="Getir"
            ref="RaporForm">
            <el-col :span="12">
              <el-form-item label="Arama Kelimesi" prop="Bilgi">
                <el-input placeholder="Açıklama da aranacak metin yazınız"
                          v-model="Form.Bilgi"></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="3" :offset="9">
              <el-button type="primary" class="btn-block mt-3" size="medium" @click="Getir"
                         icon="el-icon-check">Rapor Oluştur
              </el-button>
            </el-col>
          </el-form>
        </el-row>
      </div>
      <el-table
        v-if="tableDisplay"
        class="table-xs yazdirma"
        :data="tableData"
        style="width: 100%"
        width="100%"
        :height="Height"
      >
        <el-table-column
          label="İşlem Tarihi"
          prop="Tarih"
          width="150">
        </el-table-column>
        <el-table-column
          label="Ödeme Tarihi"
          prop="oTarihi"
          width="100">
        </el-table-column>
        <el-table-column
          label="Muhatap"
          prop="Muhatap"
          width="200">
        </el-table-column>
        <el-table-column
          label="Site/Bina"
          prop="Bina"
          width="200">
        </el-table-column>
        <el-table-column
          label="Kasa"
          prop="Kasa"
          width="100">
        </el-table-column>
        <el-table-column
          label="Makbuz No"
          prop="MakbuzNo"
          width="100">
          <template slot-scope="scope">
            <a v-if="scope.row.MakbuzNo" @click="MakbuzGetir(scope.row.MakbuzNo)">
              <span>{{ scope.row.MakbuzNo }}</span>
            </a>
          </template>
        </el-table-column>
        <el-table-column
          label="Açıklama"
          prop="Aciklama">
        </el-table-column>
        <el-table-column
          label="Kullanıcı"
          prop="Kullanici"
          width="100">
        </el-table-column>

        <el-table-column
          label="Tutar"
          prop="Tutar"
          width="100"
          align="right">
        </el-table-column>
      </el-table>
      <el-alert
        v-if="!Liste"
        title="Filtreleme Yapınız"
        type="info"
        :closable="false"
        class="yazdirma"
        description="Verilere erişebilemek için lütfen filtreleme yapınız"
      >
      </el-alert>

    </div>
    <MakbuzDetay v-if="MakbuzDetayModal" :mNo="mNo" @MakbuzDetayModal="MakbuzDetayModal=false"
                 :MakbuzDetayModal="MakbuzDetayModal"></MakbuzDetay>
  </div>
</template>

<script>
import Yukleniyor from "../../../components/Doc/Yukleniyor";
import MakbuzDetay from "../../../components/Pack/Vezne/MakbuzDetay";

export default {
  components: {MakbuzDetay, Yukleniyor},
  data() {
    return {
      Height: 0,
      lo: false,
      tableDisplay: false,
      SayfaAdi: 'Detaylı Makbuz Arama',
      Liste: null,
      MakbuzDetayModal: null,
      mNo: null,
      Form: {
        Bilgi: ''
      },
      FormHata: {
        Bilgi: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
      },
    }
  },
  methods: {
    MakbuzGetir(mNo) {
      this.mNo = mNo;
      this.MakbuzDetayModal = true
    },
    Getir() {
      this.$refs['RaporForm'].validate((valid) => {
        if (valid) {
          this.lo = true;
          this.$store.dispatch("Post", {...this.Form, path: 'raporlama/makbuzara/'})
            .then(response => {
              this.lo = false;
              if (response.Durum == "OK") {
                this.tableData = response.tableData;
                if (this.tableData) this.tableDisplay = true;
                this.Height = '72vh';
              } else {
                this.$message.error(response.Mesaj);
                this.hata = response.Hata;
              }
            })
        }
      })

    },

  },
  created() {
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Raporlama/ozel/makbuzarama.vue